import { Reducer } from "redux";
import { createContext } from "react";

export interface IReport {
  name: string;
  reportUrl?: string;
  request: any;
  success: boolean;
}

export interface IReportContext {
  generatedReports: Map<string, IReport>;
  accessor?: IReportContextAccessor;
}

export const initialReportContext = {
  generatedReports: new Map<string, IReport>(),
};

export interface IReportContextAccessor extends IReportContext {
  getReport(reportName: string): IReport | undefined;
}

export const ReportContext = createContext<IReportContext>(
  initialReportContext
);

export const ADD_REPORT = "ADD_REPORT";
export const REMOVE_REPORT = "REMOVE_REPORT";

export interface IReportContextAction {
  type: string;
  payload: IReport;
}

export const reportContextReducer: Reducer<
  IReportContext,
  IReportContextAction
> = (
  previousState: IReportContext = initialReportContext,
  action: IReportContextAction
) => {
  switch (action.type) {
    case ADD_REPORT:
      return {
        generatedReports: getNewMap(
          previousState.generatedReports,
          action.payload
        ),
      };

    case REMOVE_REPORT:
      return {
        generatedReports: new Map<string, IReport>(
          Array.from(previousState.generatedReports.values())
            .filter((x) => x.name !== action.payload.name)
            .map((x) => [x.name, x])
        ),
      };
  }

  return previousState;
};

const getNewMap = (previous: Map<string, IReport>, report: IReport) => {
  const map = new Map<string, IReport>(previous);
  map.set(report.name, report);
  return map;
};
